import type { AccountAttribute as AccountAttributeModel } from '@/adapters/catalogv1.g';

export function extractAccountAttribute(model: AccountAttributeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    attributeRef: model.attribute_ref ?? '',
    value: model.value ?? '',
    type: model.type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountAttribute = ReturnType<
  typeof extractAccountAttribute
>;
